<template>
  <van-list v-model="loading" :finished="finished" finished-text="暂无记录" @load="onLoad" style="overflow: scroll; height: calc(100vh)">
    <van-cell v-for="noPay in noPayList" :key="noPay" style="background-color: gainsboro;padding: 5px;">
      <template>
        <div class="div_list" @click="payInfo(noPay.parkingOrderId,2,1)">
          <div>
            <div class="div_left">{{noPay.carNum}}</div>
            <div class="div_right">查看详情》</div>
            <div class="div_clear"></div>
          </div>
          <div class="div_zt">
            <div>
              <div class="div_left">入场时间:{{noPay.startTime}}</div>
              <div v-if="noPay.status == 1" class="div_right font_red">待缴费</div>
              <div v-if="noPay.status == 0" class="div_right font_red">未缴费</div>
              <div class="div_clear"></div>
            </div>
            <div>
              <div class="div_left">出场时间:{{noPay.leaveTime}}</div>
              <div class="div_right font_red">¥{{(noPay.noPayMoney).toFixed(2)}}</div>
              <div class="div_clear"></div>
            </div>
          </div>
          <div>
            <div class="div_left">{{noPay.parkName}}</div>
            <div class="div_right">停车时长：{{noPay.parkingCarTimes}}</div>
            <div class="div_clear"></div>
          </div>
        </div>
      </template>
    </van-cell>
  </van-list>
</template>

<script>
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    data() {
      return {
        carNum: "",
        noPayList: [],
        loading: false,
        finished: false,
        openid: "",
        active: "0"
      };
    },
    methods: {
      onLoad() {
        // 异步更新数据
        this.$http.post(this.$api.noPayRecordNew, {
          carNum: this.carNum
        }).then(res => {
          if (res.data.length == 0) {
            this.finished = true;
          } else {
            this.finished = false;
            this.noPayList = res.data;
          }
          console.log(this.noPayList);
        });
        this.loading = false;
      },
      payInfo(id, type, noPay) {
        this.$router.push({
          path: '/recordInfo',
          query: {
            orderId: id,
            opType: type,
            noPay: noPay
          }
        });
      },
      //获取openId
      getopenId() {
        if (mySessionStorage.getItem("openid") != null && mySessionStorage.getItem("openid") != "" && mySessionStorage.getItem("openid") != "null") {
          this.openid = mySessionStorage.getItem("openid");
          console.log("--------------------------", this.openid);
        } else {
          this.$getOpenid().then(res => {
            this.openid = mySessionStorage.getItem("openid");
            console.log("--------------------------", this.openid);
          });
        }
      },
    },
    created() {},
    mounted() {
      this.carNum = this.$route.query.carNum;
      // console.log(encodeURI(this.carNum));
      // //this.carNum = encodeURI(this.carNum);
      // console.log(window.location.href);
      // let href = window.location.href;
      // console.log("位置:" + href.indexOf("aabbaabb"));
      // if (href.indexOf("aabbaabb") < 0) {
      //   window.location.href =
      //     "https://open.weixin.qq.com/connect/oauth2/authorize?scope=snsapi_base&response_type=code&redirect_uri=http%3A%2F%2Fapi2.ctpark.cn%2F%23%2FpayFeesRecord?carNum=" +
      //     this.carNum + "&state=aabbaabb&wechat_redirect&appid=wxa88a250b4e28abd8"
      // }else{
        this.getopenId();
      //}
    }
  };
</script>

<style>
  .div_left {
    float: left;
  }

  .div_right {
    float: right;
  }

  .div_clear {
    clear: both;
  }

  .div_list {
    padding: 2% 1%;
    background: whitesmoke;
    /* background-image: linear-gradient(to top,lightblue, white ); */
    border: 1px #F39900 dashed;
  }

  .font_red {
    color: red;
  }

  /* .div_zt {
    background-color: #F39900;
  } */
</style>



// WEBPACK FOOTER //
// src/components/user/payFees/payFeesRecord.vue